import React, { useState, useEffect } from 'react';

import { SearchInput, useT } from '@repo/common';
import SelectedSkills from './SelectedSkills';
import MobileAddSkillsBottomSheet from './MobileAddSkillsBottomSheet';

const MobileSkillsContent = ({ skill, setResumeData, $isMobile }) => {
  const t = useT();
  const [selectedSkills, setSelectedSkills] = useState(skill || []);
  const [sheetOpen, setSheetOpen] = useState(false);

  const toggleSkill = (s) =>
    setSelectedSkills((prev) =>
      prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s],
    );

  const removeSkill = (s) =>
    setSelectedSkills((prev) => prev.filter((x) => x !== s));

  useEffect(() => {
    setResumeData((prev) => ({ ...prev, skill: selectedSkills }));
  }, [selectedSkills, setResumeData]);

  return (
    <div className='flex flex-col items-start w-full gap-3'>
      <div className='w-full' onClick={() => setSheetOpen(true)}>
        <SearchInput
          value=''
          placeholder={t('Search and add skills', '스킬을 검색해 추가해 주세요')}
          activePlaceholder={t(
            'Search and add skills',
            '스킬을 검색해 추가해 주세요'
          )}
          readOnly
          onChange={() => {}}
          onFocus={() => setSheetOpen(true)}
        />
      </div>

      <SelectedSkills selected={selectedSkills} onRemove={removeSkill} />

      {sheetOpen && (
        <MobileAddSkillsBottomSheet
          selected={selectedSkills}
          onToggle={toggleSkill}
          onRemove={removeSkill}
          onClose={() => setSheetOpen(false)}
          $isMobile={$isMobile}
        />
      )}
    </div>
  );
};

export default MobileSkillsContent;
